/**
 * Data Center Prep Research — Mobile navigation toggle.
 * Lightweight hamburger menu for <=767px. No dependencies.
 * Toggles a dropdown menu exposing the primary nav links + Subscribe.
 */
export default function mobileNav() {
  function init() {
    var toggle = document.getElementById('nav-toggle');
    var menu = document.getElementById('mobile-menu');
    if (!toggle || !menu) return;

    function close() {
      menu.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', 'Open menu');
    }

    function open() {
      menu.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
      toggle.setAttribute('aria-label', 'Close menu');
    }

    toggle.addEventListener('click', function () {
      if (toggle.getAttribute('aria-expanded') === 'true') {
        close();
      } else {
        open();
      }
    });

    // Close when a menu link is followed.
    menu.addEventListener('click', function (e) {
      if (e.target.closest('a')) close();
    });

    // Close on Escape.
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') {
        close();
        toggle.focus();
      }
    });

    // Reset to closed state if the viewport grows past the mobile breakpoint.
    var mq = window.matchMedia('(min-width: 768px)');
    var onChange = function (e) { if (e.matches) close(); };
    if (mq.addEventListener) {
      mq.addEventListener('change', onChange);
    } else if (mq.addListener) {
      mq.addListener(onChange);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}
